/**
 * マニフェスト管理
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements/output_reservations`

const getDefaultState = () => {
  return {}
}

const manifest_management_output_reservation = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     * CSV出力予約
     * @param commit
     * @param conditions { Object } 検索条件
     * @param layout { String } 種別 (all: 全件, direct: 直行, transshipment: 積替保管, import: 取り込み用
     * @returns {Promise<unknown>}
     */
    create ({ commit }, { conditions, layout }) {
      const parameters = {
        layout: layout,
        ...conditions
      }
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, parameters).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '出力履歴よりご確認ください' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}

export default manifest_management_output_reservation
